import type { Transcript } from '../Transcript';
import type { TranscriptWordData } from '../../video-data/types';

type TimeRange = { startTime: number; endTime: number };

export function isSceneCutBetween(
    sceneStart: number,
    word: TranscriptWordData,
    nextWord: TranscriptWordData | undefined,
): boolean {
    return word.startTime < sceneStart && (!nextWord || sceneStart <= nextWord.startTime);
}

export function splitRangeAtSceneCuts(
    transcript: Transcript,
    range: TimeRange,
    sceneStartTimes: readonly number[],
): TimeRange[] {
    const words = transcript.getWordsWithinRange([[range.startTime, range.endTime]]);
    const ranges: TimeRange[] = [];
    let startTime = range.startTime;
    words.slice(0, -1).forEach((word, index) => {
        const nextWord = words[index + 1];
        if (!sceneStartTimes.some((sceneStart) => isSceneCutBetween(sceneStart, word, nextWord))) {
            return;
        }
        ranges.push({ startTime, endTime: word.endTime });
        startTime = nextWord.startTime;
    });
    ranges.push({ startTime, endTime: range.endTime });
    return ranges;
}
